/**
 * Recent-search persistence — query STRINGS ONLY, keyed per facility,
 * never result payloads. Cleared wholesale on logout via
 * clearAllSearchRecents() (wired in services/authService).
 */

const KEY_PREFIX = 'nyos_search_recents_v1'
const MAX_RECENTS = 8

const keyFor = (facilityId: string) => `${KEY_PREFIX}:${facilityId}`

export function loadSearchRecents(facilityId: string | undefined): string[] {
  if (!facilityId) return []
  try {
    const raw = localStorage.getItem(keyFor(facilityId))
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((s): s is string => typeof s === 'string') : []
  } catch {
    return []
  }
}

/** Prepend the query (deduped, capped); returns the new list for setState. */
export function recordSearchRecent(facilityId: string | undefined, query: string): string[] {
  const term = query.trim()
  if (!facilityId || !term) return loadSearchRecents(facilityId)
  const next = [term, ...loadSearchRecents(facilityId).filter((q) => q !== term)].slice(0, MAX_RECENTS)
  try {
    localStorage.setItem(keyFor(facilityId), JSON.stringify(next))
  } catch {
    // storage full / private mode — recents are a nicety, never a blocker
  }
  return next
}

/** Drop every facility's recents — called from authService.logout(). */
export function clearAllSearchRecents(): void {
  try {
    const doomed: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(KEY_PREFIX)) doomed.push(k)
    }
    doomed.forEach((k) => localStorage.removeItem(k))
  } catch {
    // ignore
  }
}
